import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { formatApiError } from "@/pages/AdminLogin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const empty = { current: "", next: "", repeat: "" };

const PwField = ({ label, value, onChange, testid }) => (
  <label className="block">
    <span className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[var(--ink-2)]">{label}</span>
    <input type="password" required value={value} onChange={onChange} data-testid={testid} className="mt-2 w-full border-0 border-b border-[var(--ink)]/25 bg-transparent py-2.5 text-base outline-none focus:border-[var(--clay)]" />
  </label>
);

export const ChangePassword = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(empty);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 10) { setError("Das neue Passwort braucht mindestens 10 Zeichen."); return; }
    if (f.next !== f.repeat) { setError("Die neuen Passwörter stimmen nicht überein."); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: f.current, new_password: f.next }, { withCredentials: true });
      toast.success("Passwort wurde geändert.");
      setF(empty);
      setOpen(false);
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setError(""); }}>
      <DialogTrigger asChild>
        <button data-testid="admin-change-password" className="flex items-center gap-2 text-sm text-[var(--ink-2)] hover:text-[var(--clay)]"><KeyRound className="h-4 w-4" /> <span className="hidden sm:inline">Passwort ändern</span></button>
      </DialogTrigger>
      <DialogContent className="bg-[var(--stone)] sm:max-w-md" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-d text-3xl font-normal">Passwort ändern</DialogTitle>
          <DialogDescription>Mindestens 10 Zeichen. Gilt für den Zugang zur Anfragen-Übersicht.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="mt-2 space-y-5">
          <PwField label="Aktuelles Passwort" value={f.current} onChange={set("current")} testid="change-password-current" />
          <PwField label="Neues Passwort" value={f.next} onChange={set("next")} testid="change-password-new" />
          <PwField label="Neues Passwort wiederholen" value={f.repeat} onChange={set("repeat")} testid="change-password-repeat" />
          {error && <p className="text-sm text-[#B42318]" data-testid="change-password-error">{error}</p>}
          <button type="submit" disabled={saving} data-testid="change-password-submit" className="flex w-full items-center justify-center gap-2 rounded-full bg-[var(--ink)] py-3 text-sm text-[var(--stone)] transition-[background-color] hover:bg-[var(--clay)] disabled:opacity-60">
            {saving && <Loader2 className="h-4 w-4 animate-spin" />} Speichern
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
